import React, { useEffect, useState } from 'react';
import { getUserSowing } from '../firebase/firestoreService'; // Adjust the path as necessary

// Define the crops data with their average yield ranges
const cropsData = [
  { Name: "PADDY", Average_Yield_Min: 3000, Average_Yield_Max: 4800 },
  { Name: "CHOLAM", Average_Yield_Min: 1100, Average_Yield_Max: 2900 },
  { Name: "CUMBU", Average_Yield_Min: 1100, Average_Yield_Max: 2400 },
  { Name: "RAGI", Average_Yield_Min: 900, Average_Yield_Max: 2400 },
  { Name: "MAIZE", Average_Yield_Min: 2800, Average_Yield_Max: 7700 },
  { Name: "RED GRAM", Average_Yield_Min: 700, Average_Yield_Max: 1900 },
  { Name: "BENGAL GRAM", Average_Yield_Min: 900, Average_Yield_Max: 2400 },
  { Name: "GREEN GRAM", Average_Yield_Min: 450, Average_Yield_Max: 1400 },
  { Name: "BLACK GRAM", Average_Yield_Min: 450, Average_Yield_Max: 1400 },
  { Name: "HORSE GRAM", Average_Yield_Min: 450, Average_Yield_Max: 1400 },
  { Name: "GROUNDNUT", Average_Yield_Min: 1400, Average_Yield_Max: 3400 },
  { Name: "GINGELLY", Average_Yield_Min: 800, Average_Yield_Max: 1600 },
  { Name: "POTATO", Average_Yield_Min: 14000, Average_Yield_Max: 29000 },
  { Name: "ONION", Average_Yield_Min: 14000, Average_Yield_Max: 29000 },
  { Name: "SUGARCANE", Average_Yield_Min: 29000, Average_Yield_Max: 78000 },
  { Name: "COTTON", Average_Yield_Min: 600, Average_Yield_Max: 2400 }
];

const MySowing = ({ email }) => {
  const [sowingData, setSowingData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSowingData = async () => {
      try {
        const data = await getUserSowing(email); // Fetch sowing data from Firestore
        setSowingData(data);
      } catch (err) {
        setError('Error fetching sowing data.');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    if (email) {
      fetchSowingData();
    }
  }, [email]);

  if (loading) return <loading />;

  if (error) {
    return <div style={styles.error}>{error}</div>;
  }

  // Function to calculate the number of days since sowing
  const calculateDaysSinceSowing = (sowingDate) => {
    const currentDate = new Date();
    const sowingDateObj = new Date(sowingDate.seconds * 1000); // Convert Firestore timestamp to Date object

    const timeDifference = currentDate - sowingDateObj; // Time difference in milliseconds
    const daysDifference = Math.floor(timeDifference / (1000 * 3600 * 24)); // Convert ms to days

    return daysDifference;
  };

  // Function to find the crop details based on crop name
  const getCropDetails = (cropName) => {
    return cropsData.find(crop => crop.Name === cropName);
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.header}>My Sowing Data</h2>
      {sowingData.length === 0 ? (
        <p>No sowing data available.</p>
      ) : (
        <div style={styles.tableWrapper}>
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={styles.th}>Crop Name</th>
                <th style={styles.th}>Expected Yield (Kgs)</th>
                <th style={styles.th}>Yield Range / Hectare (Tones)</th>
                <th style={styles.th}>Field Size (hectare)</th>
                <th style={styles.th}>Sowing Date</th>
                <th style={styles.th}>Days Since Sowing</th>
              </tr>
            </thead>
            <tbody>
              {sowingData.map((sowing, index) => {
                const cropDetails = getCropDetails(sowing.crop_name);
                const fieldSize = sowing.field_size;

                // Calculate the expected yield for the field size
                const expectedYieldMin = cropDetails ? cropDetails.Average_Yield_Min : 0;
                const expectedYieldMax = cropDetails ? cropDetails.Average_Yield_Max : 0;

                return (
                  <tr key={index} style={index % 2 === 0 ? styles.tableRowEven : styles.tableRowOdd}>
                    <td style={styles.td}>{sowing.crop_name}</td>
                    <td style={styles.td}>{`${sowing.expected_yield}`}</td>
                    <td style={styles.td}>{`${expectedYieldMin} - ${expectedYieldMax}`}</td>
                    <td style={styles.td}>{fieldSize}</td>
                    <td style={styles.td}>{new Date(sowing.sowing_date.seconds * 1000).toLocaleDateString()}</td>
                    <td style={styles.td}>{calculateDaysSinceSowing(sowing.sowing_date)}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

const styles = {
  container: {
    margin: '40px auto',
    padding: '20px',
    fontFamily: 'Arial, sans-serif',
    borderRadius: '12px',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    width: '90%',
    backgroundColor: 'rgba(255, 255, 255, 0.3)',
    border: '2px solid rgba(255, 255, 255, 0.9)',
  },
  header: {
    fontSize: '24px',
    fontWeight: '600',
    padding: '0px 0px 10px',
    textAlign: 'center',
    color: '#ffff',
  },
  tableWrapper: {
    overflowX: 'auto',
    borderRadius: '12px',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    borderRadius: '12px',
    tableLayout: 'fixed',
  },
  th: {
    padding: '8px 16px',
    backgroundColor: '#4CAF50',
    color: '#fff',
    textAlign: 'left',
    cursor: 'pointer',
    fontWeight: 'bold',
    fontSize: '14px',
  },
  td: {
    padding: '8px 16px',
    textAlign: 'left',
    borderBottom: '1px solid #ddd',
    fontSize: '14px',
  },
  tableRowEven: {
    backgroundColor: '#f9f9f9',
  },
  tableRowOdd: {
    backgroundColor: '#ffffff',
  },
  loading: {
    fontSize: '16px',
    textAlign: 'center',
    marginTop: '20px',
  },
  error: {
    color: 'red',
    fontWeight: 'bold',
    textAlign: 'center',
    marginTop: '20px',
  },
};

export default MySowing;
